import { storyblokEditable } from "@storyblok/react/rsc";
import { ComponentProps, default as React } from "react";
import { EmbeddedHTML as EmbeddedHTMLUI, PredefinedScript } from "@repo/ui-parkmobile/EmbeddedHTML";
import type { EmbeddedHTML } from "@/generated/sb";

export type EmbeddedHTMLProps = {
  blok: EmbeddedHTML;
} & Omit<ComponentProps<typeof EmbeddedHTMLUI>, "html" | "predefinedScript">;

export function EmbeddedHTML({ blok, ...props }: EmbeddedHTMLProps) {
  // The Storyblok type field directly maps to the predefined script keys
  const predefinedScript = blok.type as PredefinedScript | undefined;

  return (
    <EmbeddedHTMLUI
      {...storyblokEditable(blok)}
      {...props}
      html="" // The OneTrust script will inject the content
      predefinedScript={predefinedScript}
    />
  );
}
